<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-map"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 0: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-map tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Card: Formulario -->
      <div class="form-card-container">
        <div class="form-card">
          <div class="card-header">
            <div class="card-header-icon">
              <i class="pi pi-file-edit"></i>
            </div>
            <span class="card-header-title">{{ texts.dados_do_estado }}</span>
          </div>
          <div class="card-content">
            <div class="form-grid">
              <!-- Nome (third) -->
              <div class="form-field third">
                <label class="form-label">{{ labels.nome }} <span class="required">*</span></label>
                <input type="text" pInputText [(ngModel)]="form.nome"
                  [placeholder]="placeholders.nome" class="w-full"
                  [class.error-field]="isFormSubmitted && !form.nome" />
              </div>
              <!-- Codigo Fatura Eletronica (third) -->
              <div class="form-field third">
                <label class="form-label">{{ labels.codigo_fatura_eletronica }} <span class="required">*</span></label>
                <input type="number" pInputText [(ngModel)]="form.codigoFaturaEletronica"
                  [placeholder]="placeholders.codigo_fatura_eletronica" class="w-full"
                  [class.error-field]="isFormSubmitted && !form.codigoFaturaEletronica" />
              </div>
              <!-- Pais (third) -->
              <div class="form-field third">
                <label class="form-label">{{ labels.pais }} <span class="required">*</span></label>
                <p-dropdown [options]="paises" optionLabel="label" dataKey="value"
                  [(ngModel)]="form.pais"
                  [placeholder]="placeholders.selecione"
                  [showClear]="false" [filter]="false" appendTo="body"
                  [class.error-field]="isFormSubmitted && !form.pais">
                  <ng-template pTemplate="selectedItem" let-pais>
                    <div class="dropdown-pais-item" *ngIf="pais">
                      <img [src]="pais.flagUrl" class="flag-icon-small" alt="" />
                      <span>{{ pais.label }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="item" let-pais>
                    <div class="dropdown-pais-item">
                      <img [src]="pais.flagUrl" class="flag-icon-small" alt="" />
                      <span>{{ pais.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparForm()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.salvar"
          icon="pi pi-check" (click)="submit()" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.atualizar"
          icon="pi pi-check" (click)="salvarEdicaoEstado()" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 1: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <!-- Card: Tabela de Estados -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.tabela_de_estados }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.novo_estado"
              icon="pi pi-plus" (click)="novoEstado()" class="btn-primary btn-sm">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="filterName"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="estados" [loading]="loading"
            (onSort)="onSortChange($event)"
            [sortField]="lastfield" [sortOrder]="lastSort === 'asc' ? 1 : -1"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 7%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 25%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('pais')" pSortableColumn="pais" style="width: 18%">
                  {{ labels.pais }}<p-sortIcon [field]="'pais'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('codigoFaturaEletronica')" pSortableColumn="codigoFaturaEletronica" style="width: 18%">
                  {{ labels.codigo_fatura_eletronica }}<p-sortIcon [field]="'codigoFaturaEletronica'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 18%">
                  {{ labels.data_da_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-estado>
              <tr>
                <td [hidden]="!isColumnVisible('id')">{{ estado.id }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ estado.nome }}</td>
                <td [hidden]="!isColumnVisible('pais')">{{ estado.pais?.nome || '-' }}</td>
                <td [hidden]="!isColumnVisible('codigoFaturaEletronica')">{{ estado.codigoFaturaEletronica }}</td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ estado.criadoEm | date: 'dd/MM/yyyy' }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarEstado(estado)">
                  </button>
                  <button pButton icon="pi pi-trash"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletarEstado(estado.id)">
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_estado }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($event)"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first3" [rows]="rows"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
